function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './AVIFactTileSmall.scss';
export var AVIFactTileSmall = /*#__PURE__*/function (_Component) {
  _inheritsLoose(AVIFactTileSmall, _Component);

  function AVIFactTileSmall() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = AVIFactTileSmall.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        title = _this$props.title,
        ToolsComponent = _this$props.toolsComponent;
    return /*#__PURE__*/React.createElement("div", {
      className: 'avi-fact-tile-small fact-tile-small'
    }, /*#__PURE__*/React.createElement("div", {
      className: 'avi-fact-header fact-header'
    }, /*#__PURE__*/React.createElement("h4", null, title, ":")), /*#__PURE__*/React.createElement("div", {
      className: 'avi-fact-container fact-container'
    }, children), ToolsComponent && /*#__PURE__*/React.createElement(ToolsComponent, null));
  };

  return AVIFactTileSmall;
}(Component);

_defineProperty(AVIFactTileSmall, "defaultProps", {});

AVIFactTileSmall.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.any,
  title: PropTypes.string,

  /**
   * If set, this component is rendered aside the content container.
   */
  toolsComponent: PropTypes.any
} : {};
export default AVIFactTileSmall;